import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" • ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_ctx.latestCheckInAverage <= 50)
    ? _withDirectives((_openBlock(), _createBlock(_component_ion_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openHelpNowModal()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            class: "o-87",
            size: "large",
            button: "",
            icon: _ctx.notificationsOutline
          }, null, 8, ["icon"]),
          _withDirectives(_createVNode(_component_ion_badge, {
            color: "danger",
            style: {"position":"relative","bottom":"6px","left":"-12px"}
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.userDetails && !_ctx.userDetails.dismissHeader]
          ])
        ]),
        _: 1
      }, 512)), [
        [_vShow, _ctx.userDetails]
      ])
    : _createCommentVNode("", true)
}